export function describeFieldChanges({ before, after, fields, formatValue }) {
  const parts = [];

  for (const [field, label] of Object.entries(fields)) {
    const beforeVal = before?.[field] ?? '';
    const afterVal = after?.[field] ?? '';
    if (String(beforeVal) === String(afterVal)) continue;

    const displayBefore = formatValue ? formatValue(field, beforeVal) : beforeVal;
    const displayAfter = formatValue ? formatValue(field, afterVal) : afterVal;
    parts.push(`${label}: ${displayBefore || '—'} → ${displayAfter || '—'}`);
  }

  return parts;
}

export function describeRecordDetails({ record, fields, exclude = [], formatValue }) {
  if (!record) return [];
  const parts = [];

  for (const [field, label] of Object.entries(fields)) {
    if (exclude.includes(field)) continue;
    const value = record[field];
    if (value === null || value === undefined || value === '') continue;

    const displayValue = formatValue ? formatValue(field, value) : value;
    parts.push(`${label}: ${displayValue}`);
  }

  return parts;
}
